import Dialog, { DialogProps } from '@ui/components/molecules/dialog/dialog.molecule';
import LoadingIndicator from '@ui/components/molecules/loading-indicator/loading-indicator.molecule';
import SuspenseLoading from '@ui/components/molecules/suspense-loading/suspense-loading.molecule';
import { PropsWithChildren, memo, useMemo, useState } from 'react';

// #region Types
type MainLayoutProps = PropsWithChildren<{
  errorDialog?: DialogProps;
  hasSuspense?: boolean;
  isLoading?: boolean;
  suspenseFallback?: React.ReactNode;
}>;
// #endregion

function BaseMainLayout({
  children,
  errorDialog,
  hasSuspense,
  isLoading,
  suspenseFallback,
}: MainLayoutProps) {
  // #region States
  const [isSuspenseLoading, setIsSuspenseLoading] = useState(false);
  // #endregion

  // #region Computed Values
  const content = useMemo(
    () =>
      hasSuspense ? (
        <SuspenseLoading
          fallback={suspenseFallback}
          onIsSuspenseChange={setIsSuspenseLoading}
          withLoadingIndicator={false}
        >
          {children}
        </SuspenseLoading>
      ) : (
        children
      ),
    [children, hasSuspense, suspenseFallback],
  );

  const dialog = useMemo(() => !!errorDialog && <Dialog {...errorDialog} />, [errorDialog]);
  // #endregion

  return (
    <div className="h-dscreen overflow-hidden">
      {content}

      <LoadingIndicator open={isLoading || isSuspenseLoading} />

      {dialog}
    </div>
  );
}
BaseMainLayout.displayName = 'MainLayout';

const MainLayout = memo(BaseMainLayout);

export default MainLayout;
